var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "ap-modal-element" }, [
      _c(
        "div",
        { staticClass: "modal-grid-two-cols stripe stripes-extra-padding" },
        [
          _c("div", { staticClass: "bold-text" }, [
            _vm._v("Наименование проекта ")
          ]),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.projectName))])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "modal-grid-two-cols stripes-extra-padding" }, [
        _c("div", { staticClass: "bold-text" }, [_vm._v("Дата создания")]),
        _vm._v(" "),
        _c("div", [_vm._v(_vm._s(_vm.dateIntoRu(_vm.createDate)))])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-grid-two-cols stripe stripes-extra-padding" },
        [
          _c("div", { staticClass: "bold-text" }, [
            _vm._v("Последние изменениия ")
          ]),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.dateIntoRu(_vm.lastUpdate)))])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "modal-grid-two-cols stripes-extra-padding" }, [
        _c("div", { staticClass: "bold-text" }, [_vm._v("Автор ")]),
        _vm._v(" "),
        _c("div", { staticClass: "ap-button-edit-category" }, [
          _c(
            "div",
            { staticClass: "table-svg-button", on: { click: _vm.selectUser } },
            [_c("SVGAdminEditRow")],
            1
          ),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              "\n                        " +
                _vm._s(_vm.user.fullname) +
                "\n                    "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-grid-two-cols stripe stripes-extra-padding" },
        [
          _c("div", { staticClass: "bold-text" }, [_vm._v("Заказчик ")]),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.customerName(_vm.customer.name)))])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "modal-grid-two-cols stripes-extra-padding" }, [
        _c("div", { staticClass: "bold-text" }, [
          _vm._v("Доступность в Lite версии ")
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "pretty p-default sidebar-checkbox" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.openRead,
                  expression: "openRead"
                }
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.openRead)
                  ? _vm._i(_vm.openRead, null) > -1
                  : _vm.openRead
              },
              on: {
                change: function($event) {
                  var $$a = _vm.openRead,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.openRead = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.openRead = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.openRead = $$c
                  }
                }
              }
            }),
            _vm._v(" "),
            _vm._m(0)
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-grid-two-cols stripe stripes-extra-padding" },
        [
          _c("div", { staticClass: "bold-text" }, [
            _vm._v("Включить доступ по ссылке ")
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "pretty p-default sidebar-checkbox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.openWrite,
                    expression: "openWrite"
                  }
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.openWrite)
                    ? _vm._i(_vm.openWrite, null) > -1
                    : _vm.openWrite
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.openWrite,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.openWrite = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.openWrite = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.openWrite = $$c
                    }
                  }
                }
              }),
              _vm._v(" "),
              _vm._m(1)
            ])
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("img", {
      staticStyle: {
        display: "block",
        margin: "5px auto",
        "max-width": "95%",
        "max-height": "270px"
      },
      attrs: { src: _vm.urlForPhoto(_vm.getFirstImg()) }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "ap-projects-modal-btn-grid" }, [
      _c("div", { staticClass: "modal-button", on: { click: _vm.apply } }, [
        _vm._v("\n                Сохранить\n            ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal-button",
          on: {
            click: function($event) {
              return _vm.confirmTransition(_vm.projectData)
            }
          }
        },
        [_vm._v("\n                Редактировать проект\n")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "state p-danger" }, [_c("label")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "state p-danger" }, [_c("label")])
  }
]
render._withStripped = true

export { render, staticRenderFns }